<div class="header">
  <div class="icon-types">
    @for (format of formats; track format) {
      <div class="icon-type" [class.active]="activeSection === format" (click)="activeSection = format">
        {{ format }}
      </div>
    }
  </div>
  <div class="bcg-color-list">
    @for (color of colors; track color) {
      <div class="bgc-color-item" [style.background-color]="color" (click)="nextColor(color)"></div>
    }
    <img
      src="assets/svg/support.svg"
      width="24"
      height="24"
      matTooltip='You can press "SHIFT + X" to switch background color'
      matTooltipClass="blue-md-tooltip wide"
      matTooltipShowDelay="200"
    />
  </div>
</div>
<div class="icon-container" [style.background-color]="activeColor">
  @for (icon of activeIcons; track icon) {
    <div class="icon-card">
      <img [src]="icon" width="100%" style="max-height: 70px; max-width: 80px" (click)="showIconInfo(icon)" />
    </div>
  }
</div>
